/* eslint-disable unicorn/better-regex */
const EMAIL_REGEX =
  /^(([^<>()[\]/\\.,;:\s@"]+(\.[^<>()[\]/\\.,;:\s@"]+)*)|(".+"))@((\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}\])|(([a-zA-Z\-\d]+\.)+[a-zA-Z]{2,}))$/;

export const isValidEmail = (email: null | string | undefined): boolean => {
  if (!email) return false;

  return EMAIL_REGEX.test(email);
};
